import { Contact } from "@interfaces/contact-us"
import { Result } from "@lib/api/services/result"
import ContactUsRepositories from "@repositories/contact-us.repositories"

export default class ContactUsServices extends ContactUsRepositories {
  async submitContactUs(body: Contact) {
    try {
      const res = await this.rawSubmitContactUs({ data: body })

      const { error, result } = await this._getResponse<any>(res)

      if (error || !result) {
        return Result.fail<any>()
      }

      return Result.ok<any>(result)
    } catch (e: any) {
      return Result.fail<any>()
    }
  }
}
